<script setup lang="ts">
import { object, string } from "yup";
import { Form, Field, ErrorMessage } from "vee-validate";
import { onMounted, reactive } from "vue";
const { searchNumberWithPrice } = useOnlineShopping();

definePageMeta({ layout: false, hideChatBox: true });

const initialValues = reactive({
  prefix: "021",
  price: "0",
  searchedPhone: "",
  userCaptchaCode: "",
  numberType: "9169",
});
const isCaptchaValid = ref(false);

const schema = object({
  prefix: string().required(
    "برای مشاهده لیست شماره‌ها کد استان مورد نظر را وارد نمایید ."
  ),
  numberType: string().test(
    "is-selected",
    "لطفا پیش شماره را انتخاب کنید",
    (value) => {
      return !!value;
    }
  ),
  userCaptchaCode: string()
    .required("کد امنیتی را وارد نمایید .")
    .test("", "کد وارد شده معتبر نمی‌باشد.", () => isCaptchaValid.value),
});

const currentGoldPage = ref(1);
const currentSilverPage = ref(1);
const currentOpalPage = ref(1);
const itemsPerPage = 5;
const isLoading = ref(false);
const isFirstSearch = ref(true);

const selectNumberType = (value) => {
  initialValues.numberType = value;
};

const numberTypes = [
  { value: "9169", text: "9169" },
  { value: "8280", text: "8280" },
  { value: "8721", text: "8721" },
  { value: "8164", text: "8164" },
];

function getCaptchaStatus(isValid, value) {
  isCaptchaValid.value = isValid;
  initialValues.userCaptchaCode = value;
}

const getNumbers = async (form) => {
  isLoading.value = true;
  const { data, error } = await searchNumberWithPrice({
    body: {
      prefix: form.prefix + form.numberType,
      price: form.price == 0 ? "" : form.price,
      number: form.searchedPhone,
    },
  });
  currentOpalPage.value = 1;
  currentSilverPage.value = 1;
  currentGoldPage.value = 1;
  isFirstSearch.value = false;
  isLoading.value = false;
  if (!error.value && data.value) {
    const jsonData = toRaw(data.value);
    itemsGold.value = jsonData
      .find(e => e.title === "Gold")
      .did.map(e => {
        return {
          id: String(e.id),
          phone: e.number,
          display: e.display,
          price: e.price.toString().split(".")[0],
        };
      });
    itemsSilver.value = jsonData
      .find(e => e.title === "Silver")
      .did.map(e => {
        return {
          id: String(e.id),
          phone: e.number,
          display: e.display,
          price: e.price.toString().split(".")[0],
        };
      });
    itemsOpal.value = jsonData
      .find(e => e.title === "Bronze")
      .did.map(e => {
        return {
          id: String(e.id),
          phone: e.number,
          display: e.display,
          price: e.price.toString().split(".")[0],
        };
      });
  }
};

const onPageChange = (value, type) => {
  switch (type) {
    case "gold":
      currentGoldPage.value = value;
      break;
    case "silver":
      currentSilverPage.value = value;
      break;
    case "opal":
      currentOpalPage.value = value;
      break;
  }
};

const itemsGold = ref([]);
const itemsSilver = ref([]);
const itemsOpal = ref([]);

const paginateItems = (items, currentPage) => {
  const start = (currentPage - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return items.slice(start, end);
};

const computedItemsGold = computed(() => {
  return paginateItems(itemsGold.value, currentGoldPage.value);
});
const computedItemsSilver = computed(() => {
  return paginateItems(itemsSilver.value, currentSilverPage.value);
});
const computedItemsOpal = computed(() => {
  return paginateItems(itemsOpal.value, currentOpalPage.value);
});

const totalGoldPages = computed(() => {
  return Math.ceil(itemsGold.value.length / itemsPerPage);
});
const totalSilverPages = computed(() => {
  return Math.ceil(itemsSilver.value.length / itemsPerPage);
});
const totalOpalPages = computed(() => {
  return Math.ceil(itemsOpal.value.length / itemsPerPage);
});

const options = [
  { value: "021", text: "تهران (021)" },
  { value: "031", text: "اصفهان (031)" },
  { value: "026", text: "البرز (026)" },
  { value: "071", text: "فارس (071)" },
  { value: "041", text: "آذربایجان شرقی (041)" },
  { value: "051", text: "خراسان رضوی (051)" },
  { value: "087", text: "کردستان (087)" },
  { value: "076", text: "هرمزگان (076)" },
];

const city = computed(() => {
  if (
    initialValues.numberType === "8280" ||
    initialValues.numberType === "8164" ||
    initialValues.numberType === "8721"
  ) {
    return options.filter((item) => item.value == "021");
  } else {
    return options;
  }
});

watch(
  () => initialValues.numberType,
  (newVal) => {
    if (
      newVal === "8280" ||
      newVal === "8164" ||
      newVal === "8721"
    ) {
      initialValues.prefix = "021";
    }
    initialValues.price = "0";
  }
);

const prices = [
  { value: "200000", text: "200,000", type: "9169" },
  { value: "300000", text: "300,000", type: "9169" },
  { value: "500000", text: "500,000", type: "9169" },
  { value: "700000", text: "700,000", type: "9169" },
  { value: "1000000", text: "1,000,000", type: "9169" },
  { value: "3000000", text: "3,000,000", type: "9169" },
  { value: "5000000", text: "5,000,000", type: "9169" },
  { value: "7000000", text: "7,000,000", type: "9169" },
  { value: "10000000", text: "10,000,000", type: "9169" },
  { value: "15000000", text: "15,000,000", type: "9169" },
  { value: "500000", text: "500,000", type: "8280" },
  { value: "800000", text: "800,000", type: "8280" },
  { value: "1000000", text: "1,000,000", type: "8721" },
  { value: "1000000", text: "1,000,000", type: "8164" },
  { value: "1500000", text: "1,500,000", type: "8280" },
  { value: "3500000", text: "3,500,000", type: "8280" },
  { value: "5500000", text: "5,500,000", type: "8280" },
  { value: "8000000", text: "8,000,000", type: "8280" },
  { value: "9000000", text: "9,000,000", type: "8280" },
  { value: "10000000", text: "10,000,000", type: "8280" },
  { value: "11000000", text: "11,000,000", type: "8280" },
  { value: "13500000", text: "13,500,000", type: "8280" },
  { value: "16500000", text: "16,500,000", type: "8280" },
  { value: "19700000", text: "19,700,000", type: "8280" },
  { value: "20250000", text: "20,250,000", type: "8280" },
  { value: "29550000", text: "29,550,000", type: "8280" },
];

const filterPrices = computed(() => {
  let list;
  switch (initialValues.numberType) {
    case "9169":
      list = prices.filter((item) => item.type === "9169");
      break;
    case "8280":
      list = prices.filter((item) => item.type === "8280");
      break;
    case "8164":
      list = prices.filter((item) => item.type === "8280" || item.type === "8164");
      break;
    case "8721":
      list = prices.filter((item) => item.type === "8280" || item.type === "8721");
      break;
  };
  return [ 
    { value: "0", text: "قیمت خط(تومان)", isSelected: true, }, 
    ...list 
  ];
});
</script>

<template>
  <div class="bg-blue-200 min-h-screen">
    <HeadersNumbers title="مشاهده شماره‌های نواتل" />
    <div class="container px-4 lg:px-0">
      <h3 class="py-10">جستجو در لیست خطوط نواتل</h3>
      <Form
        class="w-full grid grid-cols-1 lg:grid-cols-6 gap-1 lg:gap-4"
        :validation-schema="schema"
        :initial-values="initialValues"
        @submit="getNumbers"
      >
        <div>
          <label>انتخاب پیش‌شماره</label>
          <BaseInputSelect
            name="numberType"
            classes="w-full rounded-lg border border-blue-500 px-4 py-2 h-[42px]"
            :options="numberTypes"
            v-model="initialValues.numberType"
            :onChange="e => selectNumberType(e.target.value)"
          />
        </div>
        <div>
          <label>انتخاب استان</label>
          <BaseInputSelect
            name="prefix"
            classes="w-full rounded-lg border border-blue-500 px-4 py-2 h-[42px]"
            :options="city"
            v-model="initialValues.prefix"
          />
        </div>
        <div>
          <label>قیمت (تومان)</label>
          <BaseInputSelect
            name="price"
            classes="w-full rounded-lg border border-blue-500 px-4 py-2 h-[42px]"
            :options="filterPrices"
            v-model="initialValues.price"
          />
        </div>
        <div>
          <label>جستجو شماره</label>
          <BaseInput
            name="searchedPhone"
            type="text"
            classes="w-full rounded-lg border border-blue-500 pl-8 h-[42px]"
            placeholder="شماره را وارد کنید"
            heightAuto
            isNumber
          >
            <template #appendIcon>
              <div class="h-full aspect-square absolute end-0 rounded-e-lg flex justify-center items-center text-blue-700">
                <IconSearch />
              </div>
            </template>
          </BaseInput>
        </div>
        <div class="flex flex-col mt-[25px]">
          <Field v-show="isFirstSearch" as="div" name="userCaptchaCode">
            <Captcha @captchaStatus="e => getCaptchaStatus(e.isValid, e.value)" />
            <ErrorMessage
              name="userCaptchaCode"
              class="text-sm text-red-500"
            />
          </Field>
          <div v-show="!isFirstSearch" />
        </div>
        <div class="flex items-center">
          <Button 
            id="oshop-offCode" 
            size="Large"
            :loading="isLoading"
            class="w-full mt-5 lg:mt-0"
          >
            مشاهده شماره‌ها
          </Button>
        </div>
      </Form>
      <h4 class="py-10">نمونه شماره های نواتلی</h4>
      <div class="flex flex-col lg:flex-row gap-5">
        <div
          v-if="isFirstSearch || computedItemsOpal.length"
          class="justify-between flex flex-col w-full lg:w-1/3"
        >
          <div class="justify-center">
            <div class="w-full p-4 mt-8 text-center rounded-md border-blue-500 font-bold bg-[#BA7A5D]">
              شماره های برنزی
            </div>
            <BasePhoneCard
              v-for="item in computedItemsOpal"
              :key="item.id"
              :phone="item.display"
              :price="(+item.price).toLocaleString() + ' تومان'"
              customClass="bg-[#BA7A5D] border-[#BA7A5D]"
            />
          </div>
          <BasePagination
            :currentPage="currentOpalPage"
            :totalPages="totalOpalPages"
            type="opal"
            @pagechanged="onPageChange"
          />
        </div>
        <div
          v-if="isFirstSearch || computedItemsSilver.length"
          class="justify-between flex flex-col w-full lg:w-1/3"
        >
          <div class="justify-center">
            <div class="w-full p-4 mt-8 text-center rounded-md border-blue-700 font-bold bg-[#8E8585]">
              شماره های نقره ای
            </div>
            <BasePhoneCard
              v-for="item in computedItemsSilver"
              :key="item.id"
              :phone="item.display"
              :price="(+item.price).toLocaleString() + ' تومان'"
              customClass="bg-[#8E8585] border-[#8E8585]"
            />
          </div>
          <BasePagination
            :currentPage="currentSilverPage"
            :totalPages="totalSilverPages"
            type="silver"
            @pagechanged="onPageChange"
          />
        </div>
        <div
          v-if="isFirstSearch || computedItemsGold.length"
          class="justify-between flex flex-col w-full lg:w-1/3"
        >
          <div class="justify-center">
            <div class="w-full p-4 mt-8 text-center rounded-md border-blue-700 font-bold bg-[#D4AF37]">
              شماره های طلایی
            </div>
            <BasePhoneCard
              v-for="item in computedItemsGold"
              :key="item.id"
              :phone="item.display"
              :price="(+item.price).toLocaleString() + ' تومان'"
              customClass="bg-[#D4AF37] border-[#D4AF37]"
            />
          </div>
          <BasePagination
            :currentPage="currentGoldPage"
            :totalPages="totalGoldPages"
            type="gold"
            @pagechanged="onPageChange"
          />
        </div>
      </div>
      <div
        v-if="
          !isFirstSearch &&
          !computedItemsOpal.length &&
          !computedItemsSilver.length &&
          !computedItemsGold.length
        "
        class="text-red-500 mt-1 ms-1 h-16 font-bold flex justify-center items-center"
      >
        شماره‌ای با مشخصات وارد شده موجود نمی‌باشد.
      </div>
    </div>
  </div>
</template>
